import AbstractAPI from '../../common/AbstractAPI';
import { HTTPMethod } from '../../common/Constants';

interface SpendCreditsParams {
  amount: number;
  contentId?: number;
}

interface GenerateVideoEditParams {
  contentId: number;
  prompt_text: string;
  start_time: number;
  duration: number;
  image_reference?: string;
}

class ContentEditAPI extends AbstractAPI {
  static spendCredits(params: SpendCreditsParams) {
    const url = this.getBaseUrl() + '/api/content-edit/spend-credits';

    return this.request(url, this.buildFetchOptions(HTTPMethod.POST, params));
  }

  static generateVideoEdit(params: GenerateVideoEditParams): Promise<Response> {
    const url = this.getBaseUrl() + '/api/video/generate-edit';

    return this.request(url, this.buildFetchOptions(HTTPMethod.POST, params));
  }

  static getPurchaseInfo(): Promise<Response> {
    const url = this.getBaseUrl() + '/api/subscriptions/change/options';

    return this.request(url, this.buildFetchOptions(HTTPMethod.GET));
  }

  static getOptIns() {
    const url = this.getBaseUrl() + '/api/user/opt-ins';

    return this.request(url, this.buildFetchOptions(HTTPMethod.GET));
  }

  static doOptIn(optInName: string) {
    const url = this.getBaseUrl() + '/api/user/opt-ins';

    const body = {
      optInName,
    };

    return this.request(url, this.buildFetchOptions(HTTPMethod.PUT, body));
  }

  static checkVideoEditStatus(): Promise<Response> {
    const url = this.getBaseUrl() + '/api/video/generate-edit/status';

    return this.request(url, this.buildFetchOptions(HTTPMethod.GET));
  }
}

export default ContentEditAPI;
